
import { AxiosError } from "axios";
import useApi, { Model, Query } from "../common/hooks/useApi";
import {
    JsonHubProtocol,
    HubConnectionState,
    HubConnectionBuilder,
    LogLevel
} from '@microsoft/signalr';

export interface EquipoProcesamiento extends Model {
    Nombre:string

}

export interface EquipoProcesamientoForm extends EquipoProcesamiento {
}


export default () => {
    const module = "EquipoProcesamiento";
    const api = useApi({ module });


    return {
        list: (query: Query) => api.list!<EquipoProcesamiento>(query),
        save: (data: Partial<EquipoProcesamiento>) => api.save!<Partial<EquipoProcesamiento>, EquipoProcesamiento>(data),
        delete: (id: number) => api.delete!<EquipoProcesamiento>(id),
        listCategorias:async (query: Query) => {
            try {
                
                query.$orderby = query.$orderby ?? ["Categoria desc"];
                let qs = api.queryToString({...query,...{$apply:["groupby((Categoria))"]}});
                const response = await api.axiosInstance.get<EquipoProcesamiento[]>(`${module}?${qs}`);
                return {
                    data: {value:response.data}
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        

    };
}